import { createAsyncThunk } from "@reduxjs/toolkit";
import { ApplicationsAPI } from "api/api/applicationsApi/applicationsApi";
import { PutApplicationsMarathonExcelParams } from "api/api/applicationsApi/types";
import axios from "axios";

export const putApplicationsMarathonExcel = createAsyncThunk<
  void,
  PutApplicationsMarathonExcelParams
>(
  "applications/putApplicationsMarathonExcel",
  async ({ marathonId, ...params }, { rejectWithValue }) => {
    try {
      await ApplicationsAPI.putApplicationsMarathonExcel({
        marathonId,
        ...params,
      });
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        console.error(
          "Error while updating applications marathon excel",
          error.response?.data
        );
        return rejectWithValue(error.response?.data || "Unknown error");
      } else {
        console.error(
          "Error while updating applications marathon excel",
          error
        );
        return rejectWithValue(
          "Что-то пошло не так... Попробуйте обновить страницу"
        );
      }
    }
  }
);
